import { Segmented, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import GenericMain from "./generic/GenericMain";
import JobSpecificMain from "./jobSpecific/JobSpecificMain";
import {
  getFreeJobSpecificFilterApi,
  getGenericFilterApi,
  getJobSpecificFilterApi,
  getModuleAccessInfoApi,
} from "../../../api/candidate";
import WebUtils from "../../../utils/WebUtils";
import Loader from "../../Loader";
import { getUuid } from "pdfjs-dist";
import Utils from "../../../utils/Utils";
import { Link, useSearchParams } from "react-router-dom";
import { HelpCircle, RotateCcw } from "lucide-react";

const userDetail = Utils.getUserDetail();

const PracticeMain = () => {
  const path = window.location.pathname; // "/practiceGuide/GD_NPG1757493605"
  const guideId = path.split("/")[2]; // "GD_NPG1757493605"
  const [searchParams] = useSearchParams();
  const industryId = searchParams.get("industryId");

  const [tab, setTab] = useState("Job-specific Questions");
  const [filterData, setFilterData] = useState({});
  const [specificFilterData, setSpecificFilterData] = useState({});
  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState(false);

  const getGenericFilterFunc = async () => {
    const url = `${getGenericFilterApi}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          const industryType = result?.data?.data?.industryType;
          const category = result?.data?.data?.category;
          const difficulty = ["Easy", "Medium", "Hard"];
          setFilterData({
            industryType,
            category,
            difficulty,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getSpecificQuestionFilterFunc = async () => {
    let url;
    if (industryId) {
      url = `${getFreeJobSpecificFilterApi}?jobGuideIdentifier=${guideId}`;
    } else {
      url = `${getJobSpecificFilterApi}?jobGuideIdentifier=${guideId}&userIdentifier=${userDetail?.userIdentifier}`;
    }

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          const difficulties = ["Easy", "Medium", "Hard"];
          const skills = result.data.data?.skills?.filter(
            (item) => item !== null
          );

          setSpecificFilterData({ difficulties, skills });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
          console.log(result.data.data);
          // setModuleInfo((prev) => ({ ...prev, credits: 0 }));
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getGenericFilterFunc();
    getSpecificQuestionFilterFunc();
    getModuleInfo();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="text-center relative">
        <div className="text-xl text-[#0F1B23] font-semibold">
          Practice Interview Questions
        </div>
        <div className="text-base font-medium text-[#475467]">
          From HR to technical challenges, test yourself and build confidence
        </div>
        <div className="xl:absolute flex justify-center items-center gap-x-2 mt-3 text-center top-1 right-1">
          <Tooltip
            title={
              <>
                <div className="font-medium text-center text-[.88rem] text-orangish">
                  Credits Left:{" "}
                  <span className="font-bold">
                    {moduleInfo?.answerSubmissionCredits}
                  </span>
                </div>
                <div className="text-white text-center">
                  This shows the number of credits you have left to submit and
                  evaluate your answers.
                </div>
              </>
            }
            overlayInnerStyle={{
              padding: "10px 14px",
              background: "#0F1B23",
            }}
          >
            <div className="flex gap-1 items-center justify-center text-[.83rem] font-semibold border border-[#FEC84B] bg-[#FFFAEB] text-[#0F1B23] rounded-full hover-effect px-3 py-[.3rem] cursor-pointer">
              <RotateCcw
                size={16}
                className="cursor-pointer"
                onClick={() => getModuleInfo()}
              />
              Answer Credits:{" "}
              {moduleInfo?.answerSubmissionCredits > 0 ? (
                <span className="text-green-600 font-mono text-[.98rem] font-semibold">
                  {moduleInfo?.answerSubmissionCredits}
                </span>
              ) : (
                <span className="text-red-500 font-mono text-[1rem] font-semibold">
                  {moduleInfo?.answerSubmissionCredits}
                </span>
              )}
            </div>
          </Tooltip>
          <Link to={"/credits"}>
            <button className="py-[.35rem] px-[.9rem] text-[.9rem] btn-orange">
              Buy Credits
            </button>
          </Link>
        </div>
        <div className="mt-3 orange-segment flex justify-center items-center">
          <Segmented
            options={[
              {
                label: "Job-specific Questions",
                value: "Job-specific Questions",
              },
              {
                label: "Generic Questions",
                value: "Generic Questions",
              },
            ]}
            onChange={(value) => {
              setTab(value);
            }}
          />{" "}
        </div>

        <div className="flex flex-col items-center justify-center pt-2 pb-4">
          {tab === "Generic Questions" && (
            <GenericMain
              filterData={filterData}
              setLoading={setLoading}
              loading={loading}
              userDetail={userDetail}
              guideId={guideId}
              setModuleInfo={setModuleInfo}
              moduleInfo={moduleInfo}
            />
          )}
          {tab === "Job-specific Questions" && (
            <JobSpecificMain
              specificFilterData={specificFilterData}
              setLoading={setLoading}
              loading={loading}
              guideId={guideId}
              userDetail={userDetail}
              industryId={industryId}
              setModuleInfo={setModuleInfo}
              moduleInfo={moduleInfo}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default PracticeMain;
